'use strict';

/* global $ */

import { Ajax } from '../utils/ajax';

class Geo {
    constructor(options) {
        this.opt = $.extend({}, {
            city:  options.selector + '__city',
            current: options.selector + '__current',
            frequency: options.selector + '__frequency',
            currentFull: options.selector + '__current-full'
        }, options);
        let self = this;

        if (typeof ymaps !== 'undefined') {
            ymaps.ready(function() {
                $(self.opt.selector).each(function() {
                    self.init(this);
                });
            });
        } else {
            let count = 0;
            let timerId = setInterval(function() {
                count++;
                console.log('[ Map/test ] ' + count);
                if (typeof ymaps !== 'undefined') {
                    ymaps.ready(function() {
                        $(self.opt.selector).each(function() {
                            self.init(this);
                        });
                    });
                    clearInterval(timerId);
                }
                if (count > 2) {
                    clearInterval(timerId);
                }
            }, 500);
        }
    }

    init(el) {
        console.log('[ Geo/Init ]');
        let self = this;
        let $el = $(el);

        /* Определение геопозиции браузером
        function success(position) {
            const latitude  = position.coords.latitude;
            const longitude = position.coords.longitude;
            console.log(latitude, longitude);
        }

        function error() {
            console.log('Unable to retrieve your location');
        }

        if (!navigator.geolocation) {
            console.log('Geolocation is not supported by your browser');
        } else {
            navigator.geolocation.getCurrentPosition(success, error);
        }
        */
        ymaps.geolocation.get({
            // Выставляем опцию для определения положения по ip    
            provider: 'auto',
            // Карта автоматически отцентрируется по положению пользователя.
            // mapStateAutoApply: true
        }).then(function (result) {
            console.log(result.geoObjects);
            let coords = result.geoObjects.position;
            ymaps.geocode(coords).then(function (res) {
                let firstGeoObject = res.geoObjects.get(0);
                console.log('AddressLine', firstGeoObject.getAddressLine());
                console.log(firstGeoObject.getLocalities(), firstGeoObject.getThoroughfare(), firstGeoObject.getPremiseNumber(), firstGeoObject.getPremise());
                let country = firstGeoObject.getCountry();
                let areas = firstGeoObject.getAdministrativeAreas();
                let localities = firstGeoObject.getLocalities();
                $('.js-geodata').append(country + '\n').append(areas + '\n').append(localities + '\n');
                console.log(localities, localities.length);

                if (localities.length) {
                    self.setLocation(el, areas, localities);
                    /*
                    let params = {
                        location: [...areas, ...localities],
                        areas: areas,
                        localities: localities
                    };
                    Ajax.get('set_location', params).then((data) => {
                        if (data.ok) {
                            console.log(data);
                            if (data.stream) {
                                $el.attr('data-stream', data.stream);
                                $el.attr('data-area', areas[0]);
                                $el.attr('data-localitie', localities[0]);
                                //$el.children('span').text(data.stream);
                            }
                        } else {
                            console.error('Can\'t set location');
                        }
                    }).catch(function(error) {
                        throw new Error(error);
                    });
                    */
                }
            });
        });
    }

    setLocation(el, areas, localities) {
        let self = this;
        let $el = $(el);
        let params = {
            location: [...areas, ...localities],
            areas: areas,
            localities: localities
        };
        Ajax.get('set_location', params).then((data) => {
            if (data.ok) {
                console.log(data);
                if (data.stream) {
                    $el.attr('data-stream', data.stream);
                    $el.attr('data-area', areas[0] || '');
                    $el.attr('data-localitie', localities[0]);
                    //$el.children('span').text(data.stream);
                    $(self.opt.current).text(localities[0]);
                    $(self.opt.frequency).text(data.frequency);
                    $(self.opt.currentFull).text(localities[0] + (areas[0] ? ', ' + areas[0] : ''));
                    $(self.opt.city).removeClass('is-hidden');
                }
            } else {
                console.error('Can\'t set location');
            }
        }).catch(function(error) {
            throw new Error(error);
        });
    }

    setConfirmLocation() {
        Ajax.get('set_confirm_location', {}).then((data) => {
            if (data.ok) {
                console.log(data);
            } else {
                console.error('Can\'t set confirm location');
            }
        }).catch(function(error) {
            throw new Error(error);
        });
    }
}

export {
    Geo
};
